<template>
  <div
    class="fixed top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 w-8/12 box-border p-4 bg-mine-shaft text-yellow-500"
    v-if="alertLandscapeView"
  >
    Per un corretto funzionamento del configuratore orienta il dispositivo in
    orizzontale.
  </div>

  <div class="loader" id="loader" :class="{ hidden: isLoadingPanelActive }">
    <span class="icon">
      <Cog8ToothIcon />
    </span>
  </div>

  <div
    class="save-project-btn"
    :class="{ '!hidden': !isDownLoadable }"
    id="save-project"
    @click="saveImage"
  >
    <span class="icon">
      <ArrowDownTrayIcon />
    </span>
    <span class="label">Salva</span>
  </div>

  <transition>
    <div class="config-panel-wrapper" :class="{ active: isConfigPanelActive }">
      <div
        @click.prevent="configPanelToggle"
        class="config-panel-btn"
        :class="{ hidden: isConfigPanelActive }"
      >
        <Bars2Icon :class="{ hidden: isConfigPanelActive }" />
        <XMarkIcon :class="{ hidden: !isConfigPanelActive }" />
      </div>

      <div class="config-panel">
        <div class="config-panel-top">
          <a href="https://www.ideca.it" class="logo"
            ><img src="img/ideca-logo-gray.png"
          /></a>

          <div class="option-btns">
            <div
              class="option-btn close-panel"
              @click.prevent="configPanelToggle"
            >
              <span class="icon">
                <XMarkIcon />
              </span>
              <span class="label">Chiudi</span>
            </div>
          </div>
        </div>

        <div class="buttons-wrapper" id="config-panel">
          <!-- START BUTTONS  -->
          <div class="button-sections">
            <!-- <h4>Start</h4> -->
            <div class="buttons">
              <div v-for="(item, index) in dataPanel" :key="index">
                <div
                  class="button"
                  @click="
                    setSubPanels(item);
                    setActiveButton(index);
                  "
                  :id="item.name.replace(' ', '_') + '_' + index"
                  :class="{ active: index === activeItem }"
                >
                  <div class="thumb">
                    <img :src="get_thumb(item)" />
                  </div>
                  <div class="label">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <ButtonsPanel
            v-for="n in test"
            :key="'panel-' + Math.random() + '-' + n"
            :panel="n"
            @set-sub-panels="setSubPanels"
          ></ButtonsPanel>

          <!-- Passa i subPanels alla lista -->
        </div>
      </div>
    </div>
  </transition>

  <div class="stage-wrapper">
    <div class="stage" id="stage">
      <img
        v-for="(layer, index) in layers"
        :key="index"
        :class="'layer-' + index"
        :data-layer="index"
        :id="'layer' + index"
        v-bind:src="layer.src"
      />
      <div class="stage-gradient"></div>
      <img class="logo" src="img/ideca-logo-gray.png" />
    </div>
  </div>
</template>

<script>
//Import database from json File
import db from "../database/index.json";
import db1_0 from "../database/city_life.json";
import db1_1 from "../database/life_desire.json";
import db1_2 from "../database/life_shine.json";
import db1_3 from "../database/life_light.json";
import db2_1 from "../database/doors/general.json";
import db2_2 from "../database/doors/hotel_lobby.json";
import db2_3 from "../database/doors/villa.json";

import ButtonsPanel from "../components/ButtonsPanel.vue";

import {
  XMarkIcon,
  Bars2Icon,
  ArrowDownTrayIcon,
  Cog8ToothIcon,
} from "@heroicons/vue/24/solid";

import { computed } from "vue";

import mergeImages from "merge-images";

export default {
  name: "StageApp",
  title: "My Title",
  components: {
    ButtonsPanel,
    XMarkIcon,
    Bars2Icon,
    ArrowDownTrayIcon,
    Cog8ToothIcon,
  },
  data() {
    return {
      alertLandscapeView: false,
      show: true,
      isConfigPanelActive: false,
      isLoadingPanelActive: false,
      isDownLoadable: false,
      activeButton: -1,
      activeSubButton: -1,
      database: db,
      database1_0: db1_0,
      database1_1: db1_1,
      database1_2: db1_2,
      database1_3: db1_3,
      database2_1: db2_1,
      database2_2: db2_2,
      database2_3: db2_3,
      layersNumber: 11,
      layers: {},
      imagePath: "./layers/",
      defaulImage: "transparent.webp",
      imageStart: "High-Res_website-background4.webp",
      activePanel: "StagePanel0",
      dataPanel: {},
      dataSubPanels: [],
      dataButton: [
        [true, {}, true],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
        [false, {}, false],
      ],
    };
  },
  provide() {
    return {
      // explicitly provide a computed property
      dataSubPanels: computed(() => this.dataSubPanels),
      defaulImage: this.defaulImage,
      imagePath: this.imagePath,
      activeSubButton: this.activeSubButton,
    };
  },
  computed: {
    test: function () {
      var count = 0;

      for (let index = 1; index < this.dataSubPanels.length; index++) {
        const element = this.dataSubPanels[index];
        if (element.show) {
          count++;
        }
      }

      return count > 0 ? count : 0;
    },
  },
  methods: {
    setActiveButton: function (index) {
      //???
      this.activeItem = index;
    },
    configPanelToggle() {
      this.isConfigPanelActive = !this.isConfigPanelActive;
    },
    LoaderToggle: function () {
      this.isLoadingPanelActive = !this.isLoadingPanelActive;
    },
    DownloadToggle: function () {
      this.isDownLoadable = !this.isDownLoadable;
    },
    get_thumb: function (item) {
      if (!item.thumb) {
        return this.imagePath + this.defaulImage;
      } else {
        return this.imagePath + item.thumb;
      }
    },

    hidePanels: function (panel) {
      for (let index = panel; index < this.layersNumber; index++) {
        this.dataSubPanels[index]["sub_name"] = "";
        this.dataSubPanels[index]["name"] = "";
        this.dataSubPanels[index]["show"] = false;
        this.dataSubPanels[index]["data"] = {};
      }
    },
    setSubPanels(item, panel, index) {
      //item: contiene il sub_levels; panel è il pannello chiamato
      if (!panel || panel < 1) {
        panel = 1;
      }

      if (panel > this.layersNumber) {
        return;
      }

      //force false if necessary
      let show = true;
      let subName = "panel-button";
      if (!item.sub_levels) {
        show = false;
      } else if (typeof item.sub_levels[0].name == "undefined") {
        show = false;
      } else {
        show = true;
        subName = item.name.replace(" ", "_");
      }

      this.dataSubPanels[panel] = {
        active: -1,
        sub_name: subName,
        name: item.sezione,
        show: show,
        data: item.sub_levels,
      };

      let prevPanel = panel - 1;
      if (prevPanel > 0) {
        this.dataSubPanels[prevPanel].active = index;
      }

      //hide all subpanels after panel
      this.hidePanels(panel + 1);

      this.setStageImages(item, panel);

      this.isDownLoadable = true;
    },
    setStageImages: function (item, panel) {
      // eslint-disable-next-line
      var newData = item;
      for (let index = panel; index < this.layersNumber; index++) {
        this.layers[index] = {
          src: this.get_image(newData.image),
          name: this.cleanFileName(newData.name),
        };

        if (!newData.sub_levels) {
          newData.sub_levels = [{ image: null }];
        }
        newData = newData.sub_levels[0];
      }
    },
    getThisPanel: function (panel) {
      //panel è il pannello corrente chiamato
      if (!panel || panel < 1 || panel > this.layersNumber) {
        panel = 1;
      }

      return this.dataSubPanels[panel];
    },

    getStagePanel() {
      return this.StagePanel;
    },
    get_image: function (img) {
      //get correct image path from image name else return default image
      if (img) {
        return this.imagePath + img;
      } else {
        return this.imagePath + this.defaulImage;
      }
    },
    cleanFileName: function (name) {
      if (typeof name !== "undefined") {
        name = name.replace(" ", "_");
      } else {
        name = "";
      }

      return name;
    },
    set_images: function (dataPanel) {
      // eslint-disable-next-line
      var item = [dataPanel.data];

      var newData = dataPanel.data;
      for (let index = dataPanel.panel; index < this.layersNumber; index++) {
        this.layers[index] = {
          src: this.get_image(newData.image),
          name: this.cleanFileName(newData.name),
        };

        if (!newData.sub_levels) {
          newData.sub_levels = [{ image: null }];
        }
        newData = newData.sub_levels[0];
      }
    },
    saveImage: function () {
      this.LoaderToggle();

      var images = [];
      var filename = "";
      for (let index = 0; index < this.layersNumber; index++) {
        images.push(this.layers[index].src);

        let sep = index == 0 ? "" : "-";

        if (this.layers[index].name !== null) {
          filename = filename.concat(sep + this.layers[index].name);
        }
      }

      mergeImages(images, {
        format: "image/png",
      }).then(
        // (b64) => (document.querySelector("#save-project").href = b64)
        function (b64) {
          //document.querySelector("#save-project").href = b64;

          var a = document.createElement("a"); //Create <a>
          a.href = b64; //Image Base64 Goes here
          a.download = filename + ".png"; //File name Here
          a.click(); //Downloaded file
        }
      );

      setTimeout(this.LoaderToggle, 3000);
    },
  },
  created() {
    this.dataPanel = this.database;

    //Imposto i Layer di base con le immagini i default
    for (let index = 0; index <= this.layersNumber; index++) {
      if (index == 0) {
        this.layers[index] = {
          src: this.get_image(this.imageStart),
          name: null,
        };
      } else {
        this.layers[index] = {
          src: this.get_image(),
          name: null,
        };

        //Set default dataSubPanels values
        this.dataSubPanels[index] = {
          sub_name: "",
          active: -1,
          name: "",
          show: false,
          data: {},
        };
      }
    }

    if (!this.dataPanel[0].sub_levels) {
      this.dataPanel[0].sub_levels = [
        this.database1_0,
        this.database1_1,
        this.database1_2,
        this.database1_3,
      ];
    }
    if (!this.dataPanel[1].sub_levels) {
      this.dataPanel[1].sub_levels = [
        this.database2_1,
        this.database2_2,
        this.database2_3,
      ];
    }
  },
  mounted: function () {
    this.LoaderToggle();
    if (this.$isMobile()) {
      var mql = window.matchMedia("(orientation: portrait)");

      this.alertLandscapeView = mql.matches;

      var self = this;
      mql.addListener(function (m) {
        self.alertLandscapeView = m.matches;
        console.log("LISTENER => ", self.alertLandscapeView);
      });
    }

    this.$nextTick(() => {});
  },
  beforeUpdate: function () {
    this.$nextTick(() => {});
  },
  updated: function () {
    this.$nextTick(() => {});
  },
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>